import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {ru} from "vuetify/src/locale";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ru },
    current: "ru"
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: {
          // Green
          base: "#1a965a",
          darken1: "#4aac7d",
          lighten3: "#b3dbc9",
          lighten4: "#bbe0cf",
          lighten5: "#d1eade"
        },
        secondary: {
          // Black
          base: "#030724",
          darken4: "#000000",
          lighten1: "#525e74",
          lighten2: "#686a7c",
          lighten3: "#8a92a0",
          lighten4: "#999999",
          lighten5: "#f2f2f2"
        },
        error: {
          // Red
          base: "#ce574a",
          darken4: "#ff8585",
          lighten4: "#f5dddb",
          lighten5: "#faeeed"
        },
        info: {
          // Blue
          base: "#3474c5",
          darken4: "#316da3",
          darken2: "#157dab",
          lighten5: "#d6e3f3"
        },
        success: {
          // Green
          base: "#1a965a",
          lighten1: "#319f62"
        },
        warning: {
          // Yellow
          base: "#d9ab36",
          lighten5: "#f7eed7"
        },
        background: {
          // Grey
          base: "#8f9cac",
          darken4: "#cccccc",
          darken3: "#f5f5f5",
          darken2: "#f4f5f9",
          darken1: "#e4e4e4",
          lighten1: "#bcc5d1",
          lighten2: "#dce2ea",
          lighten3: "#ebeff5",
          lighten4: "#fff",
          lighten5: "#8f9cac"
        },
        overlay: {
          base: "#828194"
        },
        contract: {
          base: "#f3f9f6"
        },
        chart: {
          base: "#fff",
          lighten1: "#fff",
          lighten2: "#bcc5d1",
          lighten3: "#dce2ea",
          lighten4: "#d1eade",
          lighten5: "#d6e3f3",
          darken1: "#030724",
          darken2: "#525e74",
          darken3: "#3474c5",
          darken4: "#319f62",
        }
      }
    }
  }
});
